import React from 'react'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import { fetchSets, sortSets, searchSets } from "../../actions/settings"
import { fetchComprights, editCompright } from "../../actions/comprightActions"
import { addFlashMessage } from "../../actions/flashMessages"
import SettingsForm from './SettingsForm'

class SetsCompright extends SettingsForm {

  componentWillMount(){
    this.props.fetchSets('user');
    this.props.fetchComprights();
    this.props.fetchSets('comp');
  }

  modelName = 'user'

  handleChBox = (e, comp_id, user_id) => {
    const check = e.target.checked ? 1 : 0;
    this.props.editCompright({
      user_id,
      comp_id,
      check
    }, err => {
      if (err) {
        this.props.addFlashMessage({type: 'error', text: err.form});
      }
    });
  }

  render() {
    if(isEmpty(this.props.users.data)
      || isEmpty(this.props.comprights)
      || isEmpty(this.props.comps)
    ){
      return(<div>Не загружены данные</div>);
    }
    const {
      comps,
      comprights,
      users: {
        data: users,
        search,
        sort
      }
    } = this.props;

    var fltrUsers = [];
    for(var key in users){
      if(users.hasOwnProperty(key) && users[key].user_active === 1){
        if(search !== ''){
          const searchValue = "" + users[key].user_login +
            users[key].user_fname + users[key].user_lname;
          if (searchValue.toLowerCase().indexOf(search) === -1) continue;
        }
        fltrUsers.push(users[key]);
      }
    }

    const srtUsers = fltrUsers.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.user_id < b.user_id)
         return sort.asc ? -1 : 1
      if(a.user_id > b.user_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const myComps = [];
    for (let compId in comps) {
      if (
        comps.hasOwnProperty(compId) &&
        comps[compId].comp_active === 1 &&
        comps[compId].comp_own === 1
      ) {
        myComps.push(comps[compId]);
      }
    }

    const mappedUsers = srtUsers ? srtUsers.map(user => {
      return (
        <tr key={user.user_id}>
          <td>{user.user_fname} {user.user_lname} ({user.user_login})</td>
          {myComps.map(comp => {
            return(
              <td key={comp.comp_id}>
                <input
                  type="checkbox"
                  checked={
                    !!comprights[user.user_id] &&
                    (comprights[user.user_id].indexOf(comp.comp_id) !== -1)
                  }
                  onChange={e => this.handleChBox(e, comp.comp_id, user.user_id)}
                />
              </td>
            );
          })}
        </tr>
      );
    }) : [];

    return (
      <div>
        <h3 className="pull-right">Настройка доступа к компаниям</h3>
        <div className="form-group form-inline">
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.clearSearch}
                title="Очистить поиск">
                X
              </button>
            </div>
          </div>{" "}
          <div className="input-group">{fltrUsers.length} записей</div>
        </div>
        <table className="table table-striped table-hover">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th
                className="col-sm-3"
                onClick={() => {this.handleSort('user_fname',this)}}
              >
                Пользователь
              </th>
              {myComps.map(comp => {
                return(
                  <th
                    key={comp.comp_id}
                  >
                    {comp.comp_desc}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {mappedUsers}
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    users: store.users,
    comprights: store.comprights.data,
    comps: store.comps.data
  }
}

export default connect(mapOrdersToProps, {
  fetchSets,
  editCompright,
  sortSets,
  searchSets,
  fetchComprights,
  addFlashMessage
})(SetsCompright);



// WEBPACK FOOTER //
// ./src/components/settings/SetsCompright.js